'use strict';

let readConditionValues = (method) => {
    return (reader, index) => {
        reader[method](`data.alarm.condition_${index}.current`);
        reader[method](`data.alarm.condition_${index}.low`);
        reader[method](`data.alarm.condition_${index}.high`);
    };
};

let REG_TYPE = {
    0: "REG_COIL",
    1: "REG_DISCRETE",
    2: "REG_INPUT",
    3: "REG_HOLD_INT16",
    4: "REG_HOLD_INT32",
    5: "REG_HOLD_FLOAT",
    6: "REG_INPUT_INT32",
    7: "REG_INPUT_FLOAT",
    8: "REG_INPUT_INT32_AB",
    9: "REG_INPUT_INT32_CD",
    10: "REG_HOLD_INT32_AB",
    11: "REG_HOLD_INT32_CD",
};

let REG_TYPE_PARSER = (method) => {
    return {
        REG_COIL: readConditionValues(method),
        REG_DISCRETE: readConditionValues(method),
        REG_INPUT: readConditionValues(method),
        REG_HOLD_INT16: readConditionValues(method),
        REG_HOLD_INT32: readConditionValues(method),
        REG_HOLD_FLOAT: readConditionValues("readFloatLE"),
        REG_INPUT_INT32: readConditionValues(method),
        REG_INPUT_FLOAT: readConditionValues("readFloatLE"),
        REG_INPUT_INT32_AB: readConditionValues(method),
        REG_INPUT_INT32_CD: readConditionValues(method),
        REG_HOLD_INT32_AB: readConditionValues(method),
        REG_HOLD_INT32_CD: readConditionValues(method),
    };
};
let UNSIGNED_PARSER = REG_TYPE_PARSER('readUInt32LE');
let SIGNED_PARSER = REG_TYPE_PARSER('readInt32LE');

let CONDITION_PARSER = {
    0: UNSIGNED_PARSER,
    1: SIGNED_PARSER
};

let AI_MODE = {
    0: 'AI_ABOVE',
    1: 'AI_BELOW',
    2: "AI_WITHIN"
};

let UART_MODE = {
    0: 'UART_FALSE',
    1: 'UART_TRUE',
    2: 'UART_ABOVE',
    3: 'UART_BELOW',
    4: 'UART_WITHIN'
};

function parseCondition(trigger, portIndex, modeFilter) {
    return (reader, index) => {
        reader.result.set(`data.alarm.condition_${index}.trigger`, trigger);
        if (portIndex) {
            reader.result.set(`data.alarm.condition_${index}.port_index`, portIndex);
        }
        reader.readUInt8(`data.alarm.condition_${index}.mode`, modeFilter);
        let type = reader.readUInt8(`data.alarm.condition_${index}.type`, type => REG_TYPE[type]);
        let sign = reader.readUInt8(`data.alarm.condition_${index}.sign`);
        CONDITION_PARSER[sign][REG_TYPE[type]](reader, index);
    };
}

let EVENT_PARSERS = [
    parseCondition('din1', 1, () => 'IO_FALLING'),
    parseCondition('din1', 1, () => 'IO_RISING'),
    parseCondition('din1', 1, () => 'IO_HIGH'),
    parseCondition('din1', 1, () => 'IO_LOW'),
    parseCondition('din1', 1, () => 'IO_RISING_FALLING'),
    parseCondition('din2', 2, () => 'IO_FALLING'),
    parseCondition('din2', 2, () => 'IO_RISING'),
    parseCondition('din2', 2, () => 'IO_HIGH'),
    parseCondition('din2', 2, () => 'IO_LOW'),
    parseCondition('din2', 2, () => 'IO_RISING_FALLING'),
    parseCondition('MSG', 0, value => value),
    parseCondition('ALARM', 0, () => 'TIME'),
    parseCondition('SIGNAL', 0, () => 'SIGNAL_POOR'),
    parseCondition('COMMAND', 0, () => 'RESTART'),
    parseCondition('ain1', 1, value => AI_MODE[value]),
    parseCondition('ain2', 2, value => AI_MODE[value]),
    parseCondition('chn1', 1, value => UART_MODE[value]),
    parseCondition('chn2', 2, value => UART_MODE[value]),
    parseCondition('chn3', 3, value => UART_MODE[value]),
    parseCondition('chn4', 4, value => UART_MODE[value]),
    parseCondition('chn5', 5, value => UART_MODE[value]),
    parseCondition('chn6', 6, value => UART_MODE[value]),
    parseCondition('chn7', 7, value => UART_MODE[value]),
    parseCondition('chn8', 8, value => UART_MODE[value]),
];

function leftPadding(str, char, finalLength) {
    while (str.length < finalLength) {
        str = char + str;
    }
    return str;
}

function parse(reader) {
    reader.readUInt32LE("data.alarm.timestamp");
    reader.readUInt8("data.alarm.relation", value => value === 0 ? 'AND' : 'OR');
    let mask = reader.readUInt32LE("data.alarm.mask", value => leftPadding(value.toString(2), '0', 32));
    EVENT_PARSERS.filter((value, index) => mask & (1 << index)).forEach((parseCondition, index) => parseCondition(reader, index + 1));
}

module.exports.parse = parse;




// WEBPACK FOOTER //
// ./src/lib/ucp/parsers/mode/cloud/v1_1/common/alarm-parser.js